/** Значение ширины документа для отрисовки на стороне сервера  */
export const DEFAULT_DOCUMENT_WIDTH = 1024;

/** Значение высоты документа для отрисовки на стороне сервера  */
export const DEFAULT_DOCUMENT_HEIGHT = 768;

/** Ключ localStorage с коллекциями для публикации в ленту  */
export const PROMOTE_SHOW_IN_FEED_COLLECTIONS_KEY = 'promoteShowInFeedCollections';

/** Ключ localStorage с количеством показов промо для кнопки каталога в меню сайдбара  */
export const PROMOTE_SHOWS_COUNT_ADVERTISING_MENU_KEY = 'promoteShowsCountAdvertisingMenuKey';

/** Ключ localStorage с количеством показов промо для кнопки каталога при создании поста  */
export const PROMOTE_SHOWS_COUNT_ADVERTISING_POST_KEY = 'promoteShowsCountAdvertisingPostKey';

/** Ключ localStorage с количеством показов промо для кнопки каталога в профиле  */
export const PROMOTE_SHOWS_COUNT_ADVERTISING_PROFILE_KEY = 'promoteShowsCountAdvertisingProfileKey';
